import NavBar from "./NavBar";
import NavMenuLink from "./NavMenuLink";

export { NavMenuLink as MenuLink };

NavBar.MenuLink = NavMenuLink;
export default NavBar;
